/**
 * Centralized help content for all components
 * Structure: { component: { feature: { short: "...", detailed: "..." } } }
 */

export const helpContent = {
  dashboard: {
    upload: {
      short: 'Otpremite Excel ili CSV fajlove. Podržani formati: .xlsx, .xls, .csv',
      detailed: `Kako otpremiti fajl:

1. Kliknite na dugme "Otpremi" ili u sidebar-u
2. Izaberite fajl sa računara
3. Fajl će biti automatski otpremljen i dodat u listu

Podržani formati:
• Excel fajlovi (.xlsx, .xls)
• CSV fajlovi (.csv)

Fajlovi se čuvaju na nivou organizacije - svi članovi organizacije mogu da vide otpremljene fajlove.

Maksimalna veličina fajla zavisi od vašeg plana pretplate.`
    },
    currencyConverter: {
      short: 'Konvertuj valute koristeći kurs sa NBS-a za određeni datum',
      detailed: `Konvertor valuta:

1. Izaberite valutu (EUR, USD, CHF, GBP, itd.)
2. Unesite iznos za konverziju
3. Izaberite datum za koji želite kurs
4. Kliknite "Konvertuj"

Sistem automatski učitava kurs sa NBS-a (Narodna Banka Srbije) za izabrani datum i konvertuje iznos u RSD.

Napomena: Kurs se učitava sa zvaničnog API-ja NBS-a, tako da je potreban internet konekcija.

Rezultat se prikazuje u dinarima (RSD) sa dve decimale.`
    }
  },
  sidebar: {
    upload: {
      short: 'Otpremite fajlove klikom na dugme. Podržani formati: Excel i CSV',
      detailed: `Otprema fajlova:

Kliknite na dugme "+ Otpremi" da izaberete i otpremite fajl sa računara.

Vaši otpremljeni fajlovi se prikazuju ispod dugmeta. Kliknite na fajl da ga otvorite i pregledate.`
    },
    filters: {
      short: 'Filtriranje i sortiranje fajlova po vremenu, uploader-u ili nazivu',
      detailed: `Filteri i sortiranje:

SORTIRANJE:
• Sortirajte po: Vreme, Uploader, Naziv fajla
• Redosled: Rastuće (A-Z, starije→novije) ili Opadajuće (Z-A, novije→starije)

FILTRIRANJE:
• Moji fajlovi: Prikazuje samo fajlove koje ste vi otpremili
• Period: Izaberite datumski opseg (od-do) za filtriranje fajlova

Napomena: Filtriranje po uploader-u trenutno prikazuje samo vaše fajlove.`
    },
    fileActions: {
      short: 'Kliknite na fajl da ga otvorite. Preuzmite ili obrišite koristeći ikone.',
      detailed: `Akcije sa fajlovima:

• Klik na fajl: Otvara fajl za pregled i uređivanje u glavnom panelu
• Preuzmi (ikonica downloada): Preuzima originalni fajl na računar
• Obriši (ikonica korpe): Trajno briše fajl (zahteva potvrdu)

Napomena: Obrisani fajlovi se ne mogu povratiti. Budite pažljivi pri brisanju.

Informacije:
• Ime fajla: Prikazano na vrhu stavke
• Uploader: Ko je otpremio fajl
• Vreme: Kada je fajl otpremljen (zadnji put ažuriran)`
    }
  },
  filePreview: {
    saveDraft: {
      short: 'Sačuvajte svoje izmene kao draft. Draftovi se automatski čuvaju pri promeni liste.',
      detailed: `Sistem čuvanja draft-a:

AUTO-ČUVANJE:
• Draft se automatski čuva kada pređete na drugu listu u fajlu
• Vaše izmene se čuvaju bez potrebe za ručnim čuvanjem

RUČNO ČUVANJE:
• Kliknite "Sačuvaj Draft" da eksplicitno sačuvate sve izmene
• Korisno ako želite da osigurate da su sve izmene sačuvane

NAPOMENA:
• Draftovi se čuvaju po listi - svaka lista ima svoj draft
• Draftovi persistiramju između sesija - možete nastaviti gde ste stali
• Ako neko drugi u organizaciji sačuva draft istog fajla, videćete upozorenje o konfliktu
• Draftovi se razlikuju od originalnih fajlova - original se nikad ne menja

Konflikt resavanje:
• Ako dva korisnika istovremeno rade na istom fajlu, sistem će obeležiti konfliktne ćelije
• Konfliktne ćelije se prikazuju crvenom bojom
• Poslednja sačuvana izmena ima prednost`
    },
    sheetSelector: {
      short: 'Prebacujte se između različitih lista u Excel fajlu',
      detailed: `Prebacivanje između lista:

Excel fajlovi mogu imati više lista (worksheets).

Kako koristiti:
1. Kliknite na naziv liste u sheet selector-u na vrhu
2. Sistem automatski čuva draft trenutne liste pre prelaska
3. Novi sheet se učitava sa svojim draft-om (ako postoji)

Tip: Vaše izmene u jednoj listi ne utiču na druge liste - svaka lista se čuva nezavisno.`
    },
    cellEditing: {
      short: 'Dupli klik na ćeliju za uređivanje. Koristite Tab i Enter za navigaciju.',
      detailed: `Uređivanje ćelija:

NAČINI UREĐIVANJA:
• Dupli klik: Otvara ćeliju za uređivanje
• Klik na ćeliju + Enter: Otvara ćeliju za uređivanje

NAVIGACIJA:
• Tab: Sledeća ćelija desno
• Enter: Sledeća ćelija dole
• Strelice: Pomeranje između ćelija
• Shift + Strelica: Proširenje selekcije
• Escape: Otkazivanje uređivanja

SELEKCIJA:
• Klik i prevlačenje: Selektujte opseg ćelija
• Shift + Klik: Proširite selekciju
• Ctrl/Cmd + Klik: Dodajte dodatne ćelije u selekciju (ne podržano)

TIP: Vaše izmene se automatski čuvaju u draft-u kada pređete na drugu listu.`
    },
    translate: {
      short: 'Selektujte ćelije, desni klik → Translate. Izaberite script mode u navbar-u.',
      detailed: `Prevodenje teksta:

KAKO KORISTITI:
1. Selektujte ćelije koje želite da prevedete (klik i prevlačenje)
2. Desni klik na selektovane ćelije
3. Izaberite "Translate" iz kontekstnog menija
4. Tekst će biti preveden na srpski jezik

SCRIPT MODE:
• Latin: Prevod na latinici (a, b, c...)
• Cyrillic: Prevod na ćirilici (а, б, в...)
• Promenite script mode u navbar-u pre prevoda

NAPOMENA:
• Sistem koristi automatski prevod - proverite rezultate
• Prazne ćelije se ne prevode
• Brojevi i formule se ne menjaju

Tip: Možete selektovati celu kolonu ili red za masovno prevodenje.`
    },
    export: {
      short: 'Selektujte ćelije, desni klik → Export za izvoz u Taurus format',
      detailed: `Izvoz u Taurus format:

KAKO KORISTITI:
1. Selektujte ćelije koje želite da izvezete
2. Desni klik → Export
3. U modal-u, mapirajte kolone na Taurus polja:
   • Izaberite koji input column odgovara kom Taurus field-u
   • Pregled podataka vam pomaže da vidite šta izvozite
4. Kliknite "Confirm Export"
5. Preuzmite generisani .txt fajl

MAPIRANJE:
• Svako Taurus polje mora biti mapirano na jedan input column
• Možete ostaviti polja unmapped ako nisu potrebna
• Pregled podataka prikazuje prvih 6 redova za proveru

NAPOMENA:
• Izvezeni fajl je u Taurus tekstualnom formatu
• Proverite mapiranje pre izvoza da biste izbegli greške
• Sistem validira mapiranje pre izvoza`
    },
    currencyConversion: {
      short: 'Selektujte ćelije, desni klik → Convert currency. Unesite valutu i datum ili ručni kurs.',
      detailed: `Konverzija valute ili množenje:

KAKO KORISTITI:
1. Selektujte ćelije sa brojevima koje želite da konvertujete/pomnožite
2. Desni klik → "Convert currency / Multiply"
3. U modal-u izaberite opciju:

OPCIJE:
• Automatska konverzija: Unesite valutu (EUR, USD, itd.) i datum - kurs se učitava sa NBS-a
• Ručni kurs: Unesite kurs ručno (npr. 117.5)
• Samo množenje: Unesite množilac da pomnožite brojeve (bez konverzije valute)

REZULTAT:
• Selektovane ćelije sa brojevima se množe sa kursom/množiocem
• Rezultat ima 2 decimale
• Možete poništiti operaciju pomoću "Undo conversion" u kontekstnom meniju

NAPOMENA:
• Samo ćelije sa brojevima se konvertuju - tekst se ignorira
• Ne zaboravite da sačuvate draft nakon konverzije!
• Kurs se učitava sa NBS API-ja - potreban je internet`
    },
    contextMenu: {
      short: 'Desni klik na selektovane ćelije za dodatne opcije (prevod, izvoz, undo, itd.)',
      detailed: `Kontekstni meni:

Dostupne opcije kada selektujete ćelije:

• Translate: Prevod teksta na srpski (latin/ćirilica)
• Undo: Poništava poslednju izmenu
• Undo conversion: Poništava poslednju konverziju/množenje
• Redo: Ponavlja poništenu izmenu
• Copy: Kopiranje selektovanih ćelija (u razvoju)
• Paste: Nalepi kopirane ćelije (u razvoju)
• Export: Izvoz selektovanih ćelija u Taurus format
• Convert currency / Multiply: Konverzija valute ili množenje brojeva
• Script: Prebacivanje između latinice i ćirilice

TIP: Kontekstni meni se otvara na mestu gde kliknete desnim klikom.`
    }
  },
  exportModal: {
    fieldMapping: {
      short: 'Mapirajte kolone iz vaših podataka na Taurus polja. Koristite dropdown menije.',
      detailed: `Mapiranje polja za Taurus izvoz:

KAKO MAPIRATI:
1. Za svako Taurus polje, izaberite odgovarajući input column iz dropdown-a
2. "-- Unmapped --" znači da polje nije mapirano (može ostati prazno)
3. Column 1, Column 2, itd. odgovaraju redosledu kolona u vašim podacima

PREGLED PODATAKA:
• Data Preview prikazuje prvih 6 redova vaših podataka
• Koristite strelice (< >) da pomerite prikaz između kolona
• Ovo vam pomaže da vidite šta mapirate

NAPOMENA:
• Ne morate mapirati sva polja - samo ona koja su vam potrebna
• Jedan input column može biti mapiran na više Taurus polja (ako je potrebno)
• Proverite mapiranje pre potvrde izvoza

Kliknite "Confirm Export" kada završite mapiranje.`
    }
  },
  navbar: {
    scriptMode: {
      short: 'Izaberite između latinice (Latin) i ćirilice (Cyrillic) za prevod i prikaz',
      detailed: `Script Mode (Pismo):

Izaberite između dva načina pisanja:

• LATIN: Latinica (a, b, c, č, ć, d, đ, e, f...)
• CYRILLIC: Ćirilica (а, б, в, г, д, ђ, е, ж...)

KADA SE KORISTI:
• Prevodenje: Script mode određuje u kojem pismu će biti preveden tekst
• Prikaz: Neki delovi aplikacije prikazuju tekst prema izabranom script mode-u

NAPOMENA:
• Promena script mode-a utiče na buduće prevode, ne na već prevedene tekstove
• Možete promeniti script mode pre ili posle selekcije ćelija za prevod
• Script mode se čuva tokom sesije

Tip: Većina korisnika koristi latinici za rad, ali možete koristiti i ćirilicu.`
    }
  }
};

/**
 * Helper function to get help content
 * @param {string} path - Dot-separated path (e.g., 'dashboard.upload')
 * @returns {object|null} Help content object or null if not found
 */
export function getHelpContent(path) {
  const keys = path.split('.');
  let content = helpContent;
  
  for (const key of keys) {
    if (content && typeof content === 'object' && key in content) {
      content = content[key];
    } else {
      return null;
    }
  }
  
  return content;
}

